jQuery(document).ready(function ($) {

	$('.mobile-hours__button').click(function() {
		$(this).toggleClass('active');
		$('.mobile-hours__list').toggleClass('active');
	})
});
